import { useCallback, useEffect, useState } from "react";

// Trigger-once viewport flag (callback ref, so it works when the node mounts
// after async data); reduced-motion visitors get the final state immediately.
export const useInViewOnce = (threshold = 0.25) => {
  const [node, setNode] = useState(null);
  const [inView, setInView] = useState(false);
  const ref = useCallback((el) => setNode(el), []);
  useEffect(() => {
    if (!node || inView) return undefined;
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduced || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [node, inView, threshold]);
  return [ref, inView];
};
